"use client";

import { useEffect, useSyncExternalStore } from "react";

export const FOOTER_NAV_CONTEXT = {
	BLOG: "blog",
	SELLER_ACADEMY: "seller-academy",
	ADS: "ads",
};

const STORAGE_KEY = "jmt:footer-nav-context";

const read_context = () => {
	try {
		const value = sessionStorage.getItem(STORAGE_KEY);
		return Object.values(FOOTER_NAV_CONTEXT).includes(value) ? value : null;
	} catch {
		return null;
	}
};

const write_context = (value) => {
	try {
		if (value) sessionStorage.setItem(STORAGE_KEY, value);
		else sessionStorage.removeItem(STORAGE_KEY);
	} catch { }
};

// sessionStorage فقط در همین هوک و هنگام خروج از صفحه‌های حساب کاربری نوشته می‌شود،
// پس چیزی برای subscribe کردن نیست؛ useSyncExternalStore فقط تفاوت رندر سرور
// (همیشه null) و کلاینت را بدون mismatch هیدریشن حل می‌کند.
const subscribe = () => () => { };
const get_server_snapshot = () => null;

/**
 * نویگیشن پایین موبایل فقط از روی آدرس انتخاب می‌شد، پس صفحه‌های حساب کاربری
 * (`/account/...`) که نه زیرمجموعه‌ی بلاگ‌اند نه سلر آکادمی همیشه نویگیشن فروشگاه
 * می‌گرفتند؛ یعنی کاربری که از نویگیشن مجله یا سلر آکادمی «پروفایل» را می‌زد،
 * نوار را عوض‌شده می‌دید.
 *
 * بخشی که کاربر آخرین بار در آن بوده در sessionStorage نگه داشته می‌شود و فقط روی
 * صفحه‌های حساب کاربری مصرف می‌شود. با رفتن به هر صفحه‌ی دیگر (مثل فروشگاه) پاک
 * می‌شود تا نوار آن صفحه‌ها تغییر نکند.
 *
 * @returns {"blog" | "seller-academy" | null} بخشی که نویگیشن باید مال آن باشد؛
 * `null` یعنی نویگیشن فروشگاه.
 */
export default function useFooterNavContext({ isSellerAcademy, isBlogPage, isAccount, isAds = false }) {
	const stored = useSyncExternalStore(subscribe, read_context, get_server_snapshot);

	const current = isAds
		? FOOTER_NAV_CONTEXT.ADS
		: isSellerAcademy
		? FOOTER_NAV_CONTEXT.SELLER_ACADEMY
		: isBlogPage
			? FOOTER_NAV_CONTEXT.BLOG
			: null;

	useEffect(() => {
		// روی صفحه‌ی حساب کاربری مقدار ذخیره‌شده فقط خوانده می‌شود، نه بازنویسی
		if (isAccount) return;
		write_context(current);
	}, [current, isAccount]);

	if (current) return current;
	return isAccount ? stored : null;
}
